var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a-popconfirm',{attrs:{"title":_vm.$t('确定通过吗?')},on:{"confirm":_vm.handle}},[_c('a',{attrs:{"type":_vm.btnType,"disabled":_vm.submitLoading}},[_vm._v(_vm._s(_vm.$t(_vm.text)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }